/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import type { SearchResultItem } from '../../api/search/search.types';
import { getTargetUri } from '../utils/getTargetUri';
import { getCardRating } from '../utils/rating';
import { getPriceRange } from '../utils/price';
import { formatLocationName } from '../utils/formatLocationName';

import styles from './CardLinkHeading.module.scss';

interface CardLinkHeadingProps {
    item: SearchResultItem;
    id?: string;
    className?: string;
    gaTrackingId?: string;
}

export function CardLinkHeading({
    item,
    id,
    className,
    gaTrackingId,
}: CardLinkHeadingProps) {
    const targetUri = getTargetUri(item);
    const { ratingAriaLabelShort } = getCardRating(item);
    const { priceRangeAriaLabel } = getPriceRange(item);

    const formattedLocationName = formatLocationName(item.name);
    const ariaLabel = `${formattedLocationName} ${priceRangeAriaLabel ? `/ ${priceRangeAriaLabel}` : ''} ${ratingAriaLabelShort ? `/ ${ratingAriaLabelShort}` : ''} (opens in a new tab)`;

    return (
        <h2 className={cx(styles.heading, className)} id={id}>
            <a
                className={styles.cardLink}
                href={targetUri}
                target="_blank"
                rel="noopener noreferrer"
                data-ga-tracking-id={gaTrackingId}
                data-ga-tracking-value={formatLocationName(item.name)}
                aria-label={ariaLabel}
            >
                {formattedLocationName}
            </a>
        </h2>
    );
}
